// extracted by css-extract-rspack-plugin
module.exports =  {"root":"styles__root___UXdZ9","illustration":"styles__illustration___BD4Bk","form":"styles__form___P5Vg2","error":"styles__error___lCxG5"};